<template>
  <div class="box" @click.stop="moveDetail()">
    <div class="line">
      <div class="spacebetween">
        <span class="date">
          {{ $utcToLocal(result.orderTime, "YY.MM.DD") }}({{
            result.orderTime | utcGetDay
          }}) {{ $utcToLocal(result.orderTime, "HH:mm") }}
        </span>
        <span
          class="status"
          :class="{
            ongoing: result.status !== 'complete' && result.status !== 'cancel'
          }"
        >
          {{ $statusToKor(result.status) }}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.99954 17.2946C8.61026 16.9054 8.60992 16.2743 8.99877 15.8846L12.8749 12L8.99877 8.11541C8.60992 7.72572 8.61026 7.09469 8.99954 6.70541C9.38911 6.31584 10.0207 6.31584 10.4103 6.70541L14.9978 11.2929C15.3883 11.6834 15.3883 12.3166 14.9978 12.7071L10.4103 17.2946C10.0207 17.6842 9.38911 17.6842 8.99954 17.2946Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </div>
      <div class="orderId">#{{ result._id }}</div>
    </div>
    <hr />
    <div class="line second-line">
      <div class="address">
        <span class="dong-name">
          {{ result.pins[0].dongName }} ({{ result.pins[0].name }})
          <img src="@/assets/img/order/ic_caret_right.svg" />
          {{ result.pins[result.pins.length - 1].dongName }}
          ({{ result.pins[result.pins.length - 1].name }})
        </span>
      </div>
      <div class="detail">
        <div class="price">
          <span class="cancel-charge" v-if="result.status === 'cancel'">
            <span> {{ result.totalPrice.toLocaleString() }}원 </span>
            {{ result.cancelCharge.toLocaleString() }}원<i
              style="font-size: 11px; font-weight: normal"
              >(위약금)</i
            >
          </span>
          <span v-else> {{ result.totalPrice.toLocaleString() }}원 </span>
        </div>
        <div class="option">
          <span
            >{{ result.vehicleNames[0] }} ·
            {{ mixinsCountItem(result.item) }}</span
          >
        </div>
      </div>
    </div>
    <div v-if="actionVisible" class="action">
      <button
        @click.stop="$emit('openRiderLocationModal')"
        class="location"
        v-if="mixinslocationAvailable(result.status) === 'ok' && result.riderId"
      >
        <img src="@/assets/img/order/ic_location.svg" />
        <span>위치</span>
      </button>
      <button
        @click.stop="$emit('cancelOrder')"
        v-if="mixinscancelable(result.status) === 'ok'"
      >
        취소요청
      </button>
      <button
        @click.stop="$emit('reorder')"
        v-if="mixinsreorderable(result.status) === 'ok'"
      >
        재주문
      </button>
    </div>
  </div>
</template>
<script>
import mixinFilter from "@/mixins/mixinFilter";
export default {
  mixins: [mixinFilter],
  props: ["result", "actionVisible"],
  methods: {
    moveDetail() {
      if (this.actionVisible) {
        this.$router.push(`/orders/list/my/${this.result._id}`);
      }
    }
  }
};
</script>
<style scoped>
.box {
  padding: 20px 0px;
  border-bottom: 1px solid var(--gray-300);
}

.box button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  background-color: var(--white);
  border: 1px solid var(--gray-300);
  color: var(--gray-700);
}

.box button.location {
  background-color: var(--primary-100);
  color: var(--primary-500);
  border-color: transparent;
}

hr {
  border: 0.5px solid var(--gray-200);
  margin: 12px 0px;
}
.line {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.second-line {
  gap: 12px;
}

.action {
  margin-top: 20px;
  display: flex;
  gap: 8px;
}

.spacebetween {
  display: flex;
  justify-content: space-between;
}

.date {
  color: var(--gray-700);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.orderId {
  color: var(--gray-700);
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
}

.status {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  align-items: center;
}

.status.ongoing {
  color: var(--primary-400);
}

.address {
  color: var(--gray-700);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.dong-name {
  flex-wrap: wrap;
  align-items: center;
}

.dong-name img {
  width: 24px;
  height: 24px;
  margin-bottom: -6px;
}

.detail {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
}

.price {
  color: var(--gray-700);
}
.option {
  color: var(--gray-500);
}

.status_blue {
  color: var(--primary-400);
}
</style>
